import { render, staticRenderFns } from "./difficultProblems.vue?vue&type=template&id=52d0acb2&scoped=true"
import script from "./difficultProblems.vue?vue&type=script&lang=js"
export * from "./difficultProblems.vue?vue&type=script&lang=js"
import style0 from "./difficultProblems.vue?vue&type=style&index=0&id=52d0acb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0acb2",
  null
  
)

export default component.exports